import Modal from "../../components/ReactNativeModal";
import SectionTitle from "../../components/SectionTitle";
import LogisticTimesheet from "../../containers/LogisticTimesheet";
import SelectAddressSection from "../../containers/SelectAddressSection";
import { addressToScheduledAddress } from "../../containers/SelectAddressSection/SelectAddressSection-helpers";
import useFavoriteLocations from "../../ducks/user/hooks/useFavoriteLocations";
import { EVENT_TYPES, logEvent } from "../../helpers/analytics-helper";
import useNavigation from "../../hooks/useNavigation";
import useScrollLock from "../../hooks/useScrollLock";
import {
  Address,
  LogisticScheduledTaskAddress,
  LogisticScheduledTaskPeriod,
  TransportationType,
} from "../../types/server";
import BoxRatio from "../BoxRatio";
import CustomIcon from "../CustomIcon";
import { contentGenerartor } from "./ModalScheduleLogistic-helpers";
import {
  Box,
  Divider,
  Button,
  ModalContent,
  Stack,
  Typography,
  Spacer,
} from "digiwash-components";
import React, { useState, useRef, useEffect } from "react";
import {
  SafeAreaView,
  Platform,
  Alert,
  TouchableOpacity,
  ActivityIndicator,
} from "react-native";
import styled from "styled-components/native";
import CheckBox from "../CheckBox";
import { useInPerson } from "../../hooks/useInPerson";
import { useLogisticTimesheets } from "../../hooks/useLogisticTimesheets";
import { boxRatioWidth } from "../../helpers/general";
import useSyncFilterWithParam from "../../hooks/useSyncFilterWithParam";

let nativeStyles = {
  container: {
    width: "100%",
    backgroundColor: "white",
    position: "absolute",
    bottom: 0,
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
    maxWidth: 768,
    padding: 24,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.32,
    shadowRadius: 5.46,
    elevation: 9,
  },
  bar: {},
};

let webStyles = {
  container: {
    backgroundColor: "#ffffff",
    padding: 24,
    position: "fixed",
    width: "100%",
    maxWidth: 768,
    zIndex: 1,
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
    boxShadow: "0px 0px 4px rgba(33, 33, 33, 0.16)",
  },
  bar: {
    backgroundColor: "#fff",
    maxWidth: 768,
    margin: "auto",
    width: "100%",
    border: "1px solid #ccc",
    borderBottom: "",
    borderTopRightRadius: "16px",
    borderTopLeftRadius: "16px",
  },
};
let overrideStyles = Platform.OS === "web" ? webStyles : nativeStyles;
let styles = {
  ...overrideStyles,
};

let Container = Platform.OS === "web" ? Box : SafeAreaView;

const ProfileShape = styled(Box)`
  width: 100%;
  border-bottom-right-radius: 24px;
  border-bottom-left-radius: 24px;
`;

function defaultInPerson(data: Address[] | undefined) {
  return data?.find((item) => item.id === 2147483646);
}

function checkInPerson(addressId) {
  if (addressId <= 2147483647 && addressId >= 2147483600) {
    return true;
  } else {
    return false;
  }
}

interface PropTypes {
  type: TransportationType;
  selectedAddressAndTimesheet?: selectedAddressAndTimesheetType;
  visible: boolean;
  dismissModal: () => void;
  onAction: (
    selectedAddress: LogisticScheduledTaskAddress,
    selectedTimesheet: LogisticScheduledTaskPeriod
  ) => void;
  isReschedule?: boolean;
  origin_page: string;
  order_id?: number;
}

interface selectedAddressAndTimesheetType {
  address_id: number;
  address_text: string;
  period: {
    date: Date;
    end: string;
    start: string;
    id: number;
    title?: string;
  };
}

function ModalScheduleLogistic(props: PropTypes) {
  let { params } = useSyncFilterWithParam();
  let added_address = params?.added_address;
  let [currentDay, setCurrentDay] = useState<string>();
  let nav = useNavigation();
  const refScrollView = useRef(null);
  let { data: addressesData, isValidating } = useFavoriteLocations();
  let [selectedAddress, setSelectedAddress] =
    useState<LogisticScheduledTaskAddress>();
  let selectedAddressId = selectedAddress ? selectedAddress.id : undefined;
  let [selectedTimesheet, setSelectedTimesheet] =
    useState<LogisticScheduledTaskPeriod>(undefined);
  let selectedTimesheetId = selectedTimesheet
    ? selectedTimesheet.id
    : undefined;
  let { enable, disable } = useScrollLock();
  let [inPerson, setInPerson] = useState(false);
  let {
    retrieve,
    data: inPersonAddressesData,
    loading: inPersonAddressesLoading,
  } = useInPerson();
  let {
    data: timesheetsData,
    revalidate: timesheetsRevalidate,
    isValidating: timesheetsIsValidating,
    hasError: timesheetsHasError,
  } = useLogisticTimesheets();

  let text = contentGenerartor(props.type);

  useEffect(() => {
    if (added_address === "true") {
      setSelectedAddress(
        addressToScheduledAddress(addressesData[addressesData.length - 1])
      );
    } else {
      if (!!addressesData && !inPerson) {
        setSelectedAddress(addressToScheduledAddress(addressesData[0]));
      }
      if (!!inPersonAddressesData && inPerson) {
        setSelectedAddress(
          addressToScheduledAddress(defaultInPerson(inPersonAddressesData))
        );
      }
    }
  }, [addressesData, inPersonAddressesData, inPerson]);

  useEffect(() => {
    if (props.visible) {
      enable();
      if (props.selectedAddressAndTimesheet) {
        setSelectedAddress({
          id: props.selectedAddressAndTimesheet?.address_id,
          address_text: props.selectedAddressAndTimesheet?.address_text,
        });
        setSelectedTimesheet(props.selectedAddressAndTimesheet.period);
      }
    } else {
      disable();
    }
  }, [props.visible]);
  function checkAndDissmiss(dismiss) {
    let confirmationText = "";
    if (props.type === "collection") {
      confirmationText +=
        "برای ثبت تغییرات از دکمه «تنظیم زمان و مکان جمع آوری» استفاده کنید. نمیخواهید تغییرات را ذخیره کنید؟";
    } else if (props.type === "delivery") {
      confirmationText +=
        "برای ثبت تغییرات از دکمه «تنظیم زمان و مکان تحویل» استفاده کنید. نمیخواهید تغییرات را ذخیره کنید؟";
    }
    const confirmationAlert = () => {
      if (Platform.OS === "web") {
        let confirmed = confirm(confirmationText);

        if (confirmed) {
          dismiss();
          setSelectedAddress(addressToScheduledAddress(addressesData[0]));
          setSelectedTimesheet(undefined);
          if (!props.selectedAddressAndTimesheet) {
            setInPerson(false);
          }
        } else {
        }
      } else {
        Alert.alert(
          "ذخیره تغییرات",
          confirmationText,
          [
            {
              text: "انصراف",
              style: "cancel",
            },
            {
              text: "تایید",
              onPress: () => {
                dismiss();
                setSelectedAddress(addressToScheduledAddress(addressesData[0]));
                setSelectedTimesheet(undefined);
                if (!props.selectedAddressAndTimesheet) {
                  setInPerson(false);
                }
              },
            },
          ],
          { cancelable: false }
        );
      }
    };
    let isTimeSelected = !!props.selectedAddressAndTimesheet;
    if (!!props.selectedAddressAndTimesheet) {
      if (
        props.selectedAddressAndTimesheet?.address_id !== selectedAddress.id
      ) {
        confirmationAlert();
      } else if (
        !!selectedTimesheet &&
        props.selectedAddressAndTimesheet.period.id !== selectedTimesheet.id
      ) {
        confirmationAlert();
      }
    } else if (!isTimeSelected) {
      if (
        !!selectedTimesheet ||
        selectedAddress?.id !== addressToScheduledAddress(addressesData[0])?.id
      ) {
        confirmationAlert();
      }
    }
    if (
      !isTimeSelected &&
      selectedAddress?.id === addressToScheduledAddress(addressesData[0])?.id &&
      !selectedTimesheet
    ) {
      dismiss();
    }
    if (
      !!isTimeSelected &&
      props.selectedAddressAndTimesheet?.address_id === selectedAddress?.id &&
      props.selectedAddressAndTimesheet?.period?.id === selectedTimesheet?.id
    ) {
      dismiss();
    }
  }

  useEffect(() => {
    if (inPerson && !inPersonAddressesData) {
      retrieve();
    }
  }, [inPerson]);

  useEffect(() => {
    setInPerson(checkInPerson(props.selectedAddressAndTimesheet?.address_id));
  }, [props.selectedAddressAndTimesheet]);

  useEffect(() => {
    refScrollView.current?.scrollToEnd({
      animated: true,
    });
  }, [currentDay, selectedAddressId, isValidating]);

  return (
    <Modal
      isVisible={props.visible}
      onSwipeComplete={() => checkAndDissmiss(props.dismissModal)}
      onBackdropPress={() => checkAndDissmiss(props.dismissModal)}
      swipeDirection={["down"]}
      style={{
        justifyContent: "flex-end",
        margin: "auto",
        width: "100%",
        alignItems: "center",
      }}
      propagateSwipe
    >
      {addressesData && addressesData.length === 0 ? (
        <ModalContent hasContentPadding={false} refScrollView={refScrollView}>
          <>
            <BoxRatio ratio="2:1" fixedWidth={boxRatioWidth({ columns: 1 })}>
              <CustomIcon
                icon="emptyAddressesList"
                width="100%"
                height="100%"
              />
            </BoxRatio>
            <Box p="m">
              <Divider size="xxl" />
              <Typography color="neutrals.700" ff="mainBold" alignment="center">
                شما تا به حال آدرسی ثبت نکرده اید.
              </Typography>
              <Divider size="xxxl" />
              <Divider size="l" />
              <Stack distribution="center" px="xxxl">
                <Box style={{ width: "100%" }}>
                  <Button
                    onPress={() => {
                      logEvent(EVENT_TYPES.BUTTON_ADD_ADDRESS);
                      nav.navigate("NewAddress");
                    }}
                    size="l"
                  >
                    افزودن و ثبت آدرس
                  </Button>
                </Box>
              </Stack>
              <Divider size="xxxl" />
              <Divider size="l" />
            </Box>
          </>
        </ModalContent>
      ) : (
        <>
          <ModalContent hasContentPadding={false} refScrollView={refScrollView}>
            <Box>
              <Box
                pt="xxl"
                px="l"
                bg="neutrals.250"
                style={{
                  borderTopRightRadius: 12,
                  borderTopLeftRadius: 12,
                }}
              >
                <SectionTitle
                  title={text.title}
                  pb="xxl"
                  action={
                    props.type === "collection" && !props.isReschedule ? (
                      <TouchableOpacity
                        onPress={() => {
                          setInPerson(!inPerson);
                        }}
                        disabled={timesheetsIsValidating}
                      >
                        <Stack>
                          {timesheetsIsValidating ? (
                            <ActivityIndicator />
                          ) : (
                            <CheckBox
                              width={16}
                              height={16}
                              selected={inPerson}
                            />
                          )}
                          <Spacer size="m" />
                          <Typography color="neutrals.850">
                            تحویل حضوری
                          </Typography>
                        </Stack>
                      </TouchableOpacity>
                    ) : undefined
                  }
                />
              </Box>
              <ProfileShape bg="neutrals.250">
                <Box px="l">
                  <SelectAddressSection
                    data={inPerson ? inPersonAddressesData : addressesData}
                    loading={inPerson ? inPersonAddressesLoading : isValidating}
                    type={props.type}
                    onSelect={(item) => {
                      setSelectedAddress(item);
                      setSelectedTimesheet(undefined);
                    }}
                    selectedAddressId={selectedAddressId}
                    isInPerson={inPerson}
                    origin_page={props.origin_page}
                    order_id={props.order_id}
                  />
                </Box>
                <Divider size="xxxl" />
                <Divider size="xxxl" />
              </ProfileShape>
              <Stack
                style={{ width: "100%" }}
                direction="vertical"
                distribution="center"
                px="l"
                py="l"
              >
                <LogisticTimesheet
                  timeesheets={{
                    data: timesheetsData,
                    revalidate: timesheetsRevalidate,
                    isValidating: timesheetsIsValidating,
                    hasError: timesheetsHasError,
                  }}
                  type={props.type}
                  selectedAddressId={selectedAddressId}
                  selectedTimesheetId={selectedTimesheetId}
                  onSelect={(item) => {
                    setSelectedTimesheet(item);
                  }}
                  onChangeDay={(currentKey) => {
                    setCurrentDay(currentKey);
                  }}
                  isInPerson={inPerson}
                />
              </Stack>

              <>
                <Divider size="xxxl" />
                <Divider size="xxxl" />
                <Divider size="xxxl" />
              </>
            </Box>
          </ModalContent>

          <Container style={styles.container}>
            <Button
              disabled={!selectedAddress || !selectedTimesheet}
              outline
              onPress={() => {
                props.onAction(selectedAddress, selectedTimesheet);
              }}
            >
              {text.actionButton}
            </Button>
          </Container>
        </>
      )}
    </Modal>
  );
}

export default ModalScheduleLogistic;
